// Libraries
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '../../common/modules/user/services/SessionService';
import { UserService } from '../../common/modules/user/services/UserService';
import { HolidayService } from '../../holiday/services/HolidayService';

import { User } from '../../common/modules/user/models/User';
import { AdminService } from '../../common/modules/admin/services/AdminService'

@Component({
    selector: 'services-list',
    template: require('./ServicesListComponent.html'),
    styles: [require('./ServicesListComponent.sass')],
})

export class ServicesListComponent implements OnInit {
    private services: any = [];
    private hostName: string;
    private menuStatus: boolean;
    private parent: any;
    private message: any;
    private messageType: any;
    userData: User;
    constructor(
        private router: Router,
        private userService: UserService,
        private sessionService: SessionService,
        private holidayService: HolidayService,
        private adminService: AdminService
    ) {
        this.menuStatus = false
    }

    ngOnInit() {
        this.menuStatus = false
        this.hostName = window.location.hostname;

        this.sessionService.deleteSession()
            .subscribe(
                (complete: any) => {
                    // Clear user session
                    this.userService.clearUserSessionData();
                    this.adminService.clearInterSession();

                    // Fire user session data changed event
                    this.userService.userDataChanged(null);
                },
            );
    }

    toParentPortal() {
        switch (this.hostName) {
            case "services.aisvietnam.com":
                window.location.href = 'https://services.aisvietnam.com/hol-login';
                break;
            case "services.eca.dev.nascorp.vn":
                window.location.href = 'http://services.eca.dev.nascorp.vn/hol-login';
                break;
            case "services.eca.test.nascorp.vn":
                window.location.href = 'http://services.eca.test.nascorp.vn/hol-login';
                break;
            case "services.eca.uat.nascorp.vn":
                window.location.href = 'http://services.eca.uat.nascorp.vn/hol-login';
                break;
            default:
                window.location.href = 'http://services.local.eca.dev.nascorp.vn/hol-login';
                break;
        };
        this.getSession()
    }

    toAdminPortal() {
        switch (this.hostName) {
            case "services.aisvietnam.com":
                window.location.href = 'https://auth.aisvietnam.com/login';
                break;
            case "services.eca.dev.nascorp.vn":
                window.location.href = "http://auth.eca.dev.nascorp.vn/login";
                break;
            case "services.eca.test.nascorp.vn":
                window.location.href = "http://auth.eca.test.nascorp.vn/login";
                break;
            case "services.eca.uat.nascorp.vn":
                window.location.href = "http://auth.eca.uat.nascorp.vn/login";
                break;
            default:
                window.location.href = "http://auth.local.eca.dev.nascorp.vn/login";
                break;
        };
    }

    private getSession() {
        this.sessionService.getSession()
            .subscribe(
                user => {
                    // Set admin session data
                    this.userService.setUserSessionData(user);

                    // Fire admin session data changed event
                    this.userService.userDataChanged(user);

                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message = "";
                    this.messageType = "alert";
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/services/services-list/ServicesListComponent.ts